import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/question';
import { IAddQuestions, ISetMultiFileUploadId, ISetQuestionDifficulties, ISetQuestionList, ISetRefreshUploadMultiQuestion } from '../../models/action/question';

const _logger = Log.create('Question Reducer');

const addQuestionSetData = (newState: any, action: any) => {

    const pageActionPayload = (action as IAddQuestions) as any;
    const pageAction = pageActionPayload?.values ?? pageActionPayload.values;

    if(pageAction){
        newState.QuestionData = {
            questionId: pageAction.questionId,
            keywordIds: pageAction.keywordIdsRef,
            categoryIds: pageAction.categoryIdsRef ,
            masterCourseIds: pageAction.masterCourseIds ,
            courseIds: pageAction.releatedCourseId ,
            termIds: pageAction.releatedTermId ,
            topicIds: pageAction.topicIdsRef ,
            createdDate: pageAction.createdDate,
            createdByUserId: pageAction.createdByUserId ,
            questionType: pageAction.types,
            questionChoiceType: pageAction.questionChoiceType,
            questionText: pageAction.questionText,
            questionComment: pageAction.comments ,
            questionFileId: pageAction.questionFileId,
            questionFile: pageAction.questionFile,
            questionDifficulty: pageAction.questionDifficulty,
            fileUploadKey: '',
            choices: pageAction.choices,
            activeStatus: pageAction.activeStatus,
            isHtmlQuestion: pageAction.isHtmlQuestion,
            isPublicQuestion: pageAction.isPublicQuestion,
            isExamQuestion: pageAction.isExamQuestion,
            learningOutcomeId: pageAction.learningOutcomeId,
            isQuestionAssignedToTheCourse : pageAction.isQuestionAssignedToTheCourse
        };
    }
    else{
        setQuestionDefaultValues(newState);
    }
        
    
}

const setQuestionDefaultValues = (newState: any) => {
    newState.QuestionData = {
        questionId: '',
        keywordIds: '',
        categoryIds: '',
        masterCourseIds: '',
        courseIds: '',
        termIds: '',
        topicIds: '',
        qestionCreatedDate: undefined,
        qestionUpdatedDate: undefined,
        questionType: -99,
        questionChoiceType: 0,
        questionText: '',
        questionComment: '',
        questionFile: '',
        questionFileId: '',
        questionDifficulty: '',
        fileUploadKey: '',
        choices: [],
        activeStatus: 1,
        isHtmlQuestion: true,
        isPublicQuestion: false,
        isExamQuestion: false,
        learningOutcomeId: '',
    };
}

const questionReducer = (state = GlobalState().question, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {...state};
    if(action.type === Actions.actions.SET_QUESTION_LIST) {
        const examSessionPageActionPayload = action as ISetQuestionList;
        const results = examSessionPageActionPayload?.results ?? [];
        const filters = examSessionPageActionPayload?.filters ?? {};
        
        newState.QuestionDatas = {
            filters,
            results
        };
    } else if ( action.type === Actions.actions.SET_QUESTION ) {
        const examSessionPageActionPayload = action as ISetQuestionList;
        const results = examSessionPageActionPayload?.results ?? [];
        newState.QuestionDatas = {
            ...results
        };
    } else if (action.type === Actions.actions.SET_QUESTION_DEFAULT_DATA) {
        setQuestionDefaultValues(newState);
    } else if (action.type === Actions.actions.SET_QUESTION_DATA) {
        addQuestionSetData(newState, action);
    } else if (action.type === Actions.actions.SET_QUESTION_DIFFICULTIES) {
        const pageActionPayload = (action as any) as ISetQuestionDifficulties;
        const pageAction = pageActionPayload.values ?? [];
        newState.questionDifficulties = pageAction;
    } else if (action.type === Actions.actions.SET_FILE_MULTI_UPLOAD_ID) {
        const pageActionPayload = (action as any) as ISetMultiFileUploadId;
        newState.multiQuestionFileUploadId = pageActionPayload.fileUploadId;
    } else if (action.type === Actions.actions.SET_REFRESH_UPLOAD_MULTI_QUESTION) {
        const pageActionPayload = (action as any) as ISetRefreshUploadMultiQuestion;
        newState.UploadMultiQuestionResults = {
            totalQuestionsCount: pageActionPayload.model.totalQuestionsCount,
            validQuestionsCount: pageActionPayload.model.validQuestionsCount,
            invalidQuestionsCount: pageActionPayload.model.invalidQuestionsCount,
            allQuestionTypeDistribution: pageActionPayload.model.allQuestionTypeDistribution,
            validQuestionTypeDistribution: pageActionPayload.model.validQuestionTypeDistribution,
            invalidQuestionTypeDistribution: pageActionPayload.model.invalidQuestionTypeDistribution,
            wrongQuestionsFilePath: pageActionPayload.model.wrongQuestionsFilePath
        }

    }

    return Object.assign({}, state, newState);
};

export default questionReducer;
